import { Button, Grid, withStyles, WithStyles } from '@material-ui/core'
import ChevronRightIcon from 'mdi-react/ChevronRightIcon'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { stepInstantRentForward } from '../../actions/apartments'
// import nextButtonIcon from '../../../images/nextButtonIcon.svg'
import i18n from '../../translations/i18n'
import { allDefined, allValid } from '../../utils/validation/general'

const styles = () => ({
  flexButton: {
    display: 'flex',
    justify: 'space-between'
  }
})

interface NextStepButtonProps extends WithStyles, WithTranslation {
  doNextStep: any
  submit: boolean
  customLabel?: string
  beforeLogin?: boolean
  disabled?: boolean
  setIsEmpty?: any
  toValidate?: any
  toCheck?: any
}

const NextStepButton = ({
  classes,
  t,
  doNextStep,
  customLabel,
  submit,
  disabled,
  setIsEmpty,
  beforeLogin,
  toValidate,
  toCheck
}: NextStepButtonProps) => {
  // const type = submit ? 'submit' : 'button'
  const customProps: any = {}
  if (!submit) {
    customProps.onClick = doNextStep
  }
  const handleClick = (arg: any, fields: any) => {
    if (allDefined(arg) && allValid(fields)) {
      setIsEmpty(false)
      doNextStep(beforeLogin)
    } else setIsEmpty(true)
  }
  return (
    <Button
      fullWidth
      variant='contained'
      color='primary'
      className={`${classes.responsiveButton}`}
      disabled={disabled}
      onClick={() => {
        handleClick(toValidate, toCheck)
      }}
      {...customProps}
    >
      {/* {t(customLabel ? customLabel : 'apartment.actions.nextStep')}
      <img src={nextButtonIcon} /> */}
      <Grid container justify='center' alignItems='center'>
        <Grid item>{i18n.t(customLabel ? customLabel : 'general.next')}</Grid>
        <Grid item className={classes.rightFloatingIcon}>
          <ChevronRightIcon color='#D8DCDF' />
        </Grid>
      </Grid>
    </Button>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  doNextStep: (beforeLogin: boolean) =>
    dispatch(stepInstantRentForward({ beforeLogin }))
})

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(withTranslation()(NextStepButton))) as any
